export const SUBMIT_FEEDBACK_FORM  = "SUBMIT_FEEDBACK_FORM";
export const SUBMIT_FEEDBACK_FORM_SUCCESS = "SUBMIT_FEEDBACK_FORM_SUCCESS";